import $ from 'jquery';
import BlogPost from '../components/BlogPost';

export default class DynamicBlogPosts {
  constructor() {
    $('.blog-post').map(post => new BlogPost({ el: post }));
  }
}
